import { APP_DEFINITION_ID } from '@wix/wixstores-client-core';
export var getEcomInstance = function (wixCodeApi) {
    var _a, _b;
    var instance = (_b = (_a = wixCodeApi.site).getAppToken) === null || _b === void 0 ? void 0 : _b.call(_a, APP_DEFINITION_ID);
    if (!instance) {
        throw new Error('Instance is missing');
    }
    return instance;
};
//# sourceMappingURL=getEcomInstance.js.map